import { Controller } from '@hotwired/stimulus'

// I-UXC-bookings-1: a booking row of the order's Rezervace (<details name>, one open at a time). Its lazy frame loads
// on open (switched to eager: the lazy observer does not notice a <details> opening); closing swaps in a fresh unloaded
// copy, so only the open row's expanded booking is in the page (its ceník frame id „hub_price_items“ is shared by every
// booking) and reopening shows current data.
export default class extends Controller<HTMLDetailsElement> {
  static override targets = ['frame']
  declare readonly frameTarget: HTMLElement

  toggle(): void {
    if (this.element.open) {
      this.frameTarget.setAttribute('loading', 'eager')
      return
    }
    if (!this.frameTarget.hasAttribute('complete')) return

    const fresh = this.frameTarget.cloneNode(false) as HTMLElement
    for (const attribute of ['complete', 'busy', 'aria-busy']) fresh.removeAttribute(attribute)
    fresh.setAttribute('loading', 'lazy')
    this.frameTarget.replaceWith(fresh)
  }
}
